import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced } from '../../utils';
export default (function (node) {
  var locations = JSON.parse(node.getAttribute('data-locations')).map(function (location) {
    location.name = location.location_name;
    delete location.location_name;
    location.country = Array.isArray(location.country) ? location.country.join(' ') : location.country;
    return location;
  });
  var isShowControls = node.getAttribute('data-show-controls') === 'true';
  return _objectSpread({
    height: node.style.height,
    locations: locations,
    mapOptions: Object.assign({}, mapDefaultProps.mapOptions, {
      disableDefaultUI: !isShowControls,
      mapTypeControl: isShowControls
    })
  }, getAdvanced(node));
});
export var mapDefaultProps = {
  apiKey: process.env.GOOGLE_MAPS_API_KEY,
  locations: [],
  mapOptions: {
    zoom: 8,
    scrollwheel: false,
    disableDoubleClickZoom: false,
    disableDefaultUI: false,
    mapTypeControl: true
  }
};